import { render, staticRenderFns } from "./FacebookChat.vue?vue&type=template&id=7ef30c16&scoped=true"
import script from "./FacebookChat.vue?vue&type=script&lang=js"
export * from "./FacebookChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef30c16",
  null
  
)

export default component.exports